/* eslint-disable react/jsx-props-no-spreading */
import {
    useCallback,
} from 'react'
import {
    FormHelperText,
} from '@mui/material'
import {
    DatePicker,
} from '@mui/x-date-pickers/DatePicker'
import clsx from 'clsx'

import Label from 'app/shared-components/Label'
import {
    minDate,
    strToMoment,
} from 'app/utils/date'
import {
    Event,
} from 'app/types/common.types'

import useStyles from './DateSelect.style'
import {
    DateSelectCustomClasses,
} from './DateSelect.types'

type Props = {
    title?: string,
    name?: string,
    error?: string,
    onChange: (newVal: Date, e: Event<number | Date>) => void,
    value?: string,
    disabled?: boolean,
    required?: boolean,
    classes?: DateSelectCustomClasses
}

const EMPTY_OBJECT = {}

const DateSelect = ({
    title = '',
    name = '',
    error = '',
    onChange,
    value = null,
    disabled = false,
    required = false,
    classes: customClasses = EMPTY_OBJECT,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    const handleOnChange = useCallback((date: any): void => {
        const newValue = date ? new Date(date) : null

        onChange(newValue, {
            target: {
                name,
                value: newValue,
            },
        })
    }, [
        name,
        onChange,
    ])

    return (
        <div className={customClasses.container}>
            <Label
                title={title}
                className={customClasses.label}
            />
            <div
                className={clsx(
                    classes.dateField,
                    {
                        [classes.disabled]: disabled,
                        [classes.isRequired]: required,
                    },
                )}
            >
                <div className={classes.requiredMark} />
                <DatePicker
                    className={classes.input}
                    value={strToMoment(value)}
                    format="DD.MM.YYYY"
                    onChange={handleOnChange}
                    slotProps={{
                        textField: {
                            variant: 'standard',
                            fullWidth: true,
                        },
                    }}
                    disabled={disabled}
                    data-testid={`dateSelect-${name}`}
                    minDate={strToMoment(minDate)}
                />
                <FormHelperText
                    error={Boolean(error)}
                    className={clsx(classes.errorMessage, customClasses.helperText)}
                >
                    {error}
                </FormHelperText>
            </div>
        </div>
    )
}

export default DateSelect
